module.exports = __webpack_public_path__ + "img/20190529161922QQ截图20190527165106.4a0c023a.png";